<script lang="ts">
    import "@maptiler/sdk/dist/maptiler-sdk.css"
    import "@maptiler/geocoding-control/style.css"
    import { maptilerKey } from "../../../config"
    import { onMount } from "svelte"
    import { isMobile } from "../../store"
    import MagnifyableImage from "./TaskImages/MagnifyableImage.svelte"

    async function generateStaticMapImage(apiKey: string, coordinates: [number, number][]) {
        // Calculate best-fitting dimensions
        const maxHeightEl = document.getElementById(maxHeightElement)

        const container = document.getElementById("taskImagesModal")
        const container2 = document.getElementById("map-container")
        container2.style.height = container.clientHeight - 50 + "px"
        const wrapperWidth = container2.clientWidth || 800
        let wrapperHeight = container.clientHeight || 600

        wrapperHeight = Math.min(wrapperHeight, maxHeightEl.clientHeight)
        if ($isMobile) {
            wrapperHeight = 300
        }

        // Calculate aspect ratio
        const aspectRatio = wrapperWidth / wrapperHeight

        // Set the image size to the maximum possible resolution within 2048x2048 while maintaining the aspect ratio
        let imgWidth = 2048
        let imgHeight = Math.round(2048 / aspectRatio)

        if (imgHeight > 2048) {
            imgHeight = 2048
            imgWidth = Math.round(2048 * aspectRatio)
        }

        // Create the markers string for the URL
        const markers = coordinates
            .map((coord) =>
                coord && coord[1] && coord[0]
                    ? `icon:https://wohner.app/m.png|anchor:center|${coord[0]},${coord[1]}`
                    : ""
            )
            .join("|")

        // Construct the full URL for auto-fitted image
        const url = `https://api.maptiler.com/maps/outdoor-v2/static/auto/${imgWidth}x${imgHeight}@1x.png?key=${apiKey}&markers=${markers}`

        // Fetch the image
        try {
            const response = await fetch(url)
            if (!response.ok) {
                throw new Error("Failed to fetch the image")
            }
            const blob = await response.blob()
            const imageUrl = URL.createObjectURL(blob)
            return imageUrl
        } catch (error) {
            console.error("Error fetching the image:", error)
            return null
        }
    }

    export let images: { location?: { longitude: number; latitude: number } }[] = [],
        maxHeightElement: string

    $: coordinates = images
        .map((img) => [img?.location?.longitude, img?.location?.latitude] as [number, number])
        .filter((coord) => coord[0] && coord[1])

    let mapImageUrl: string | null = null
    let mounted = false
    onMount(() => {
        mounted = true
    })

    $: {
        if (mounted && coordinates.length > 0)
            generateStaticMapImage(maptilerKey, coordinates).then((url) => {
                mapImageUrl = url
            })
    }
</script>

<div
    class="map-container"
    id="map-container"
>
    {#if mapImageUrl}
        <div class="img-wrapper">
            <MagnifyableImage
                src="{mapImageUrl}"
                alt="map"
            />
        </div>
        <p>Drücken Sie auf das bild um zu zoomen.</p>
    {/if}
</div>

<style lang="less">
    .map-container {
        height: 100%;
        width: 100%;
    }
    .img-wrapper {
        width: 100%;
        height: 95%;
        overflow: hidden;
        position: relative;
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        max-width: 2048px;
        max-height: 2048px;
    }
</style>
